module.exports = __webpack_public_path__ + "static/media/twitter.4a84bfcf.png";